var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto min-h-screen" },
    [
      _c("navBar", { attrs: { title: _vm.$t("reviews.title") } }),
      _c(
        "div",
        { staticClass: "bg-white mx-4 mt-4 rounded-xl p-4 pb-3 text-center" },
        [
          _c("div", { staticClass: "flex items-center justify-center" }, [
            _c(
              "h3",
              { staticClass: "text-lg font-medium text-gray-800 mb-1 mr-3" },
              [_vm._v(_vm._s(_vm.$t("reviews.totalReviews")))]
            ),
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-center mb-1 text-2xl font-bold text-[#ff7a00]",
              },
              [_vm._v(" " + _vm._s(_vm.totalReviewsCount) + " ")]
            ),
          ]),
          _vm.$i18n.locale === "zh-CN"
            ? _c("div", { staticClass: "text-sm text-gray-500" }, [
                _vm._v(
                  " (" +
                    _vm._s(_vm.$t("reviews.totalYoyoCount")) +
                    _vm._s(_vm.totalYoyoCount) +
                    _vm._s(_vm.$t("mine.points")) +
                    ") "
                ),
              ])
            : _c("div", { staticClass: "text-sm text-gray-500" }, [
                _vm._v(
                  "(" +
                    _vm._s(_vm.totalYoyoCount) +
                    " " +
                    _vm._s(_vm.$t("reviews.totalYoyoCount")) +
                    ")"
                ),
              ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "mx-4 mt-4 bg-white rounded-xl overflow-hidden" },
        [
          _c(
            "van-tabs",
            {
              staticClass: "review-tabs yoyo-container",
              attrs: { sticky: "", "offset-top": "3rem" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "van-tab",
                {
                  attrs: {
                    title: _vm.$t("reviews.tabs.pending"),
                    name: "pending",
                  },
                },
                [
                  _vm.pendingReviews.length > 0
                    ? _c(
                        "van-pull-refresh",
                        {
                          on: { refresh: _vm.onRefreshPending },
                          model: {
                            value: _vm.pendingRefreshing,
                            callback: function ($$v) {
                              _vm.pendingRefreshing = $$v
                            },
                            expression: "pendingRefreshing",
                          },
                        },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.pendingFinished,
                                "finished-text": _vm.$t("query.noMoreData"),
                                "loading-text": _vm.$t("query.loading"),
                              },
                              on: { load: _vm.onLoadPending },
                              model: {
                                value: _vm.pendingLoading,
                                callback: function ($$v) {
                                  _vm.pendingLoading = $$v
                                },
                                expression: "pendingLoading",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                _vm._l(
                                  _vm.pendingReviews,
                                  function (review, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "py-4 border-b border-gray-100 last:border-b-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-between items-center mb-3 text-sm",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-gray-600 text-xs",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "reviews.orderNumber"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(review.itemNo)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text-gray-400 text-xs",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDate(
                                                      review.createTime
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex gap-3" },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "w-12 h-12 rounded-lg object-cover bg-gray-100",
                                              attrs: {
                                                src:
                                                  _vm.imageBaseUrl +
                                                  review.picUrl,
                                                alt: "",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-1 flex flex-col justify-between",
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-sm font-medium text-gray-800 mb-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            review.spuType
                                                          ) +
                                                          "-" +
                                                          _vm._s(
                                                            _vm.isZh
                                                              ? review.spuPlace
                                                              : review.spuPlaceEn
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-sm text-gray-600",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.isZh
                                                              ? review
                                                                  .packageValue
                                                                  ?.name
                                                              : review
                                                                  .packageValue
                                                                  ?.nameEn
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.isZh
                                                              ? review.dayValue
                                                                  ?.name +
                                                                  _vm.$t(
                                                                    "products.day"
                                                                  )
                                                              : review.dayValue
                                                                  ?.nameEn +
                                                                  _vm.$t(
                                                                    "products.day"
                                                                  )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "flex-shrink-0" },
                                              [
                                                _c(
                                                  "van-button",
                                                  {
                                                    staticClass:
                                                      "w-16 h-8 leading-10 p-0 rounded-lg bg-orange-500 border-0",
                                                    attrs: {
                                                      type: "primary",
                                                      size: "small",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleReview(
                                                          review
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reviews.reviewButton"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.pendingReviews.length === 0
                    ? _c("van-empty", {
                        attrs: { description: _vm.$t("common.noData") },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "van-tab",
                {
                  attrs: {
                    title: _vm.$t("reviews.tabs.completed"),
                    name: "completed",
                  },
                },
                [
                  _vm.completedReviews.length > 0
                    ? _c(
                        "van-pull-refresh",
                        {
                          on: { refresh: _vm.onRefreshCompleted },
                          model: {
                            value: _vm.completedRefreshing,
                            callback: function ($$v) {
                              _vm.completedRefreshing = $$v
                            },
                            expression: "completedRefreshing",
                          },
                        },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.completedFinished,
                                "finished-text": _vm.$t("query.noMoreData"),
                                "loading-text": _vm.$t("query.loading"),
                              },
                              on: { load: _vm.onLoadCompleted },
                              model: {
                                value: _vm.completedLoading,
                                callback: function ($$v) {
                                  _vm.completedLoading = $$v
                                },
                                expression: "completedLoading",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "px-4" },
                                _vm._l(
                                  _vm.completedReviews,
                                  function (review, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass:
                                          "py-4 border-b border-gray-100 last:border-b-0",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex justify-between items-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex-1" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-medium text-xs text-gray-800 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(review.productName)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-500 mb-1",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "reviews.orderNumber"
                                                        )
                                                      ) +
                                                        ": " +
                                                        _vm._s(review.itemNo)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-sm text-gray-400 mb-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(review.orderDate)
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "flex gap-3" },
                                                  [
                                                    _c("img", {
                                                      staticClass:
                                                        "w-12 h-12 rounded-lg object-cover bg-gray-100",
                                                      attrs: {
                                                        src:
                                                          _vm.imageBaseUrl +
                                                          review.picUrl,
                                                        alt: "",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex-1 flex flex-col justify-between",
                                                      },
                                                      [
                                                        _c("div", [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "font-medium text-gray-800 mb-1 text-sm",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    review.spuType
                                                                  ) +
                                                                  "-" +
                                                                  _vm._s(
                                                                    _vm.isZh
                                                                      ? review.spuPlace
                                                                      : review.spuPlaceEn
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "text-sm text-gray-600",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.isZh
                                                                      ? review
                                                                          .packageValue
                                                                          ?.name
                                                                      : review
                                                                          .packageValue
                                                                          ?.nameEn
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm.isZh
                                                                      ? review
                                                                          .dayValue
                                                                          ?.name +
                                                                          _vm.$t(
                                                                            "products.day"
                                                                          )
                                                                      : review
                                                                          .dayValue
                                                                          ?.nameEn +
                                                                          _vm.$t(
                                                                            "products.day"
                                                                          )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "bg-gray-50 rounded-lg p-3 mt-2",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex items-center mb-2",
                                                      },
                                                      [
                                                        _c("van-rate", {
                                                          attrs: {
                                                            readonly: true,
                                                            size: 14,
                                                            color: "#ffd21e",
                                                            "void-color":
                                                              "#eee",
                                                          },
                                                          model: {
                                                            value:
                                                              review.scores,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                review,
                                                                "scores",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "review.scores",
                                                          },
                                                        }),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-sm text-gray-600 ml-2",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                review.scores
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "reviews.stars"
                                                                  )
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-sm text-gray-700 mb-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(review.content)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-xs text-gray-400",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "reviews.reviewTime"
                                                            )
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                review.createTime
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.completedReviews.length === 0
                    ? _c("van-empty", {
                        attrs: { description: _vm.$t("common.noData") },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "CommonDialog",
        {
          attrs: { visible: _vm.showReviewPopup, buttons: _vm.dialogButtons },
          on: {
            "update:visible": function ($event) {
              _vm.showReviewPopup = $event
            },
            "button-click": _vm.handleButtonClick,
            close: _vm.handleClose,
          },
        },
        [
          _vm.currentReview
            ? _c("div", {}, [
                _c(
                  "div",
                  { staticClass: "mb-6 text-center" },
                  [
                    _c("van-rate", {
                      staticClass: "justify-center",
                      attrs: {
                        size: 34,
                        color: "#ffd21e",
                        "void-color": "#eee",
                      },
                      model: {
                        value: _vm.reviewForm.scores,
                        callback: function ($$v) {
                          _vm.$set(_vm.reviewForm, "scores", $$v)
                        },
                        expression: "reviewForm.scores",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex justify-center items-center flex-wrap gap-2",
                  },
                  _vm._l(_vm.reviewTags, function (tag) {
                    return _c(
                      "div",
                      {
                        key: tag.id,
                        class: [
                          "py-1 px-2 rounded-full border cursor-pointer transition-colors text-sm",
                          tag.checked
                            ? "bg-orange-500 border-orange-500 text-white"
                            : "bg-white border-gray-300 text-gray-700",
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.toggleTag(tag)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "flex items-center justify-center" },
                          [_vm._v(_vm._s(_vm.isZh ? tag.name : tag.nameEn))]
                        ),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "my-4" },
                  [
                    _c("van-field", {
                      staticClass: "bg-gray-50 rounded-lg",
                      attrs: {
                        type: "textarea",
                        placeholder: _vm.$t("reviews.reviewPlaceholder"),
                        rows: "3",
                        maxlength: "500",
                        "show-word-limit": "",
                        border: false,
                      },
                      model: {
                        value: _vm.reviewForm.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.reviewForm, "content", $$v)
                        },
                        expression: "reviewForm.content",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }